import React, { useState, forwardRef, useEffect } from "react";
import { IDateRangeProps } from "./IDatePickerProps";
import ReactPicker from "react-datepicker";
import Iconography from "@hid-galaxy-ui/galaxy-react/components/Iconography";
import classNames from "classnames";
import "react-datepicker/dist/react-datepicker.css";

const DateRange = (props: IDateRangeProps) => {
  const {
    onChange,
    format = undefined,
    isRange,
    placeholder,
    id,
    name,
    value,
    portalId,
    isDisabled = false,
    theme = "light",
    ...otherProps
  } = props;

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  useEffect(() => {
    if (Array.isArray(value)) {
      setDateRange(value as unknown as [Date | null, Date | null]);
    }
  }, [value]);

  const handleDateChange = (date: [Date | null, Date | null] | Date | null) => {
    if (Array.isArray(date)) {
      setDateRange(date as unknown as [Date | null, Date | null]);
      onChange(date);
    }
  };

  // eslint-disable-next-line react/display-name
  const CustomElement = forwardRef((datepickerProps: any, ref: any) => {
    return (
      <div onClick={datepickerProps.onClick}>
        <input
          type="text"
          className={classNames(
            "hid-form-element__control",
            "hid-form-element__control__range",
            { "hid-form-element__control--dark": theme === "dark" }
          )}
          id={id}
          name={name}
          value={datepickerProps.value}
          data-testid="date-picker"
          disabled={true}
          autoComplete="off"
          ref={ref}
          placeholder={placeholder}
        />
      </div>
    );
  });
  const [startDate, endDate] = dateRange;
  return (
    <ReactPicker
      title="date-picker"
      dateFormat={format ? format : undefined}
      selectsRange={isRange}
      startDate={startDate}
      endDate={endDate}
      customInput={<CustomElement />}
      placeholderText={placeholder}
      onChange={handleDateChange}
      {...(portalId && { portalId: portalId })}
      strictParsing={true}
      isClearable={true}
      disabled={isDisabled}
      {...otherProps}
    />
  );
};

export default DateRange;
